import React, { Component } from 'react';
import Flickity from 'flickity';
import SubSelector from '../Subselector/Subselector';
import Title from "../Title/Title"
import Content from "../Content/Content"

export default class Selector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 0,
      subSelector: false,
    }
  }

  flkty = null;
  scrollAt = null;

  componentDidMount() {
    const { subSelector, items } = this.props;
    this.scrollAt = 1 / (items.length);
    if (subSelector) {
      this.setState({
        subSelector: true,
      });
    }

    setTimeout(this.initFlickity, 0);
  }

  componentWillUnmount() {
    if (this.flkty) {
      this.flkty.destroy();
    }
  };

  initFlickity = () => {
    const options = {
      cellSelector: '.item',
      contain: false,
      accessibility: false,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true,
      cellAlign: 'right'
    }

    this.flkty = new Flickity(this.wrapper, options);

    this.flkty.on('dragStart', this.dragStart);
    this.flkty.on('dragEnd', this.dragEnd);
    this.flkty.on('scroll', this.onScroll);
    this.flkty.on('settle', this.onSettle);
  };

  prevScroll = false;

  onScroll = (scroll, sub = false) => {
    const selectedIndex = this.flkty.selectedIndex || 0;
    if (this.state.selectedIndex !== selectedIndex) {
      this.setState({
        selectedIndex: selectedIndex,
      });
    }

    if (this.dragStarted === false) {
      return;
    }

    let direction = false;

    if (this.prevScroll !== false) {
      direction = (scroll < this.prevScroll) ? 'right' : 'left';
    }

    const boundaries = {
      left: this.scrollAt * (this.state.selectedIndex ? this.state.selectedIndex : 0),
      right: (this.scrollAt * (this.state.selectedIndex ? this.state.selectedIndex + 1 : 0 + 1)) - (this.scrollAt / 2),
    }

    // When you move the slider to the left
    if (scroll > boundaries.right && direction === 'left') {
      const next = this.state.selectedIndex += 1;
      this.setState({
        selectedIndex: next,
      });

      if (sub) {
        this.slideTo(next, false);
      }
    }

    // When you move the slider to the right
    if (scroll < boundaries.left && direction === 'right' && this.state.selectedIndex !== 0) {
      const prev = this.state.selectedIndex -= 1;
      this.setState({
        selectedIndex: prev,
      });

      if (sub) {
        this.slideTo(prev, false);
      }
    }

    this.prevScroll = scroll;
  };

  slideTo = (index, updateState = true) => {
    this.flkty.selectCell(index);

    if (updateState) {
      this.setState({
        selectedIndex: index,
      });
    }
  };

  onSubSettle = index => {
    if (this.flkty && this.flkty.selectedIndex !== index) {
      this.slideTo(index, false);
    }
  };

  dragStarted = false;

  dragStart = e => {
    this.dragStarted = true;
  };

  dragEnd = e => {
    this.dragStarted = false;
  };

  render() {
    const { items } = this.props;

    return (
      <div className="w-full flex items-center peopleslider overflow-x-hidden relative">
        <div className="w-full lg:w-7/12 relative imageslider">
          <div className="w-12 top-0 right-0 bottom-0 bg-gradient-r-black"></div>
          <div className="hidden lg:block">
            {this.state.subSelector && <SubSelector onSettle={this.onSubSettle} slideTo={this.slideTo}  selectedIndex={this.state.selectedIndex ? this.state.selectedIndex : 0} items={items} />}
          </div>
          <div className="flex lg:hidden">
            <div className="flex overflow-x-scroll" ref={c => this.wrapper = c}>
              {items && items
                .filter(prop => prop.acf.show_in_slider && prop.acf.show_in_slider.includes("y"))
                .sort((a, b) => a.menu_order - b.menu_order)
                .map(item =>
                <div key={item.id} className="item w-full sm:w-1/2 ease-in-out duration-500 px-4 flex-grow-0 flex-shrink-0">
                  <div className="p-6 bg-lightorange rounded-lg relative flex items-center justify-center">
                    <div className="relative z-10">
                      <img className="inner mb-4 w-32 h-32 rounded-full bg-black flex-grow-0 flex-shrink-0 ease-in-out duration-500 object-cover" src={item.better_featured_image && item.better_featured_image.source_url} alt=""/>
                      <Title level="3">{item.title && item.title.rendered}</Title>
                      { item && item.acf && item.acf.company   && <div className="mb-4">{item.acf.company}</div>  }
                      { item.acf.short_description && <Content>{item.acf.short_description}</Content> }
                    </div>
                    <svg className="absolute w-full h-full inset-0 hidden lg:block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 755 880">
                      <defs>
                        <filter id="path-a" width="100%" height="100%" x="0%" y="0%" filterUnits="objectBoundingBox">
                          <feGaussianBlur in="SourceGraphic"/>
                        </filter>
                      </defs>
                      <path fill="#FFF7F0" fillRule="evenodd" d="M1383.04438,277.829097 C1451.19478,565.567804 1268.63481,743.065479 1016.58619,880 L1016.58619,712.582464 C809.138936,712.582464 641,553.062368 641,356.291232 C641,159.520096 809.138936,0 1016.58619,0 C1195.61082,0 1345.35394,118.801639 1383.04438,277.829097 Z" filter="url(#path-a)" transform="translate(-641)"/>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="hidden lg:block lg:w-5/12 relative overflow-hidden z-10 relative">
          <div className="flex flex-wrap lg:flex-no-wrap quoteslider flex-1">
            <div ref={c => this.wrapper = c}>
              {items && items
                .filter(prop => prop.acf.show_in_slider && prop.acf.show_in_slider.includes("y"))
                .sort((a, b) => a.menu_order - b.menu_order)
                .map(item =>
                <div key={item.id} className="item w-full gallery-cell ease-in-out duration-500">
                  <div className="p-12 lg:p-24 h-160 relative mx-auto rounded-full flex items-center justify-center">
                    <div className="relative z-10 mx-auto max-w-xs transform -translate-y-16">
                      <Title level="3">{item.title && item.title.rendered}</Title>
                      { item && item.acf && item.acf.company   && <div className="mb-4">{item.acf.company}</div>  }
                      { item.acf.short_description && <Content>{item.acf.short_description}</Content> }
                    </div>
                  </div>
                </div>
              )}
              <svg className="absolute w-full h-full inset-0" xmlns="http://www.w3.org/2000/svg" width="757" height="880" viewBox="0 0 757 880">
                <defs>
                  <filter id="quote-a" width="100%" height="100%" x="0%" y="0%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceGraphic"/>
                  </filter>
                </defs>
                <path fill="#FFF7F0" fillRule="evenodd" d="M1380.04438,277.829097 C1448.19478,565.567804 1265.63481,743.065479 1013.58619,880 L1013.58619,712.582464 C806.138936,712.582464 638,553.062368 638,356.291232 C638,159.520096 806.138936,0 1013.58619,0 C1192.61082,0 1342.35394,118.801639 1380.04438,277.829097 Z" filter="url(#quote-a)" transform="translate(-638)"/>
              </svg>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute w-6/12 right-0 top-0 bottom-0 bg-gradient-white-right"></div>
        <div className="animation-float hidden lg:block animation-ease animation-infinite animation-fill-forwards animation-10s z-0 h-60 w-60 opacity-10 absolute -left-30 bottom-4 border-40 border-orange rounded-full"></div>
      </div>
    )
  }
}
